import './App.css';
import React, { useState } from "react"
import Calculator from './components/Calculator';
import Test from './components/test';
import { useSyncPreferences } from './hooks/useSyncPreferences';

function App() {
// useSyncPreferences();

  return (
    <div className="container">
        {/* <Test /> */}
        {/* <RangeSlider /> */}
        <Calculator />
    </div>
  );
}

export default App;